import { RequestsTypesConstants } from 'src/app/core/constants/requests-side-menu.constants';
import { TablePropertiesConstants } from 'src/app/core/constants/table-properties.constant';
import { ViewDetails } from 'src/app/core/models/view-details.model';

export class callRecordTableConstants {
    public static CALL_RECORD_TABLE: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.CALL_RECORD_TABLE_COLUMNS,
        tableWithSelection: false
    };
   
}
